module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Motivos de Devolução")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Motivos de Devolução',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editando Motivos de Devolução"), (_vm.motivos && _vm.motivos.codigo) ? _c('span', [_vm._v(" (Código: " + _vm._s(_vm.motivos.codigo) + " )")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "motivos",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [(_vm.motivos && !_vm.motivos.id) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('codigo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "codigo"
    }
  }, [_vm._v("Código:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.codigo),
      expression: "motivos.codigo"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "codigo",
      "type": "text",
      "minlength": "1",
      "ng-maxlength": "255",
      "placeholder": "Informe um identificador para o motivo, no padrão, como por exemplo SEM_DOCUMENTO"
    },
    domProps: {
      "value": (_vm.motivos.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.motivos, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('codigo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('codigo')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('descricao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "descricao"
    }
  }, [_vm._v("Descrição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.descricao),
      expression: "motivos.descricao"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "descricao",
      "type": "text",
      "minlength": "1",
      "ng-maxlength": "255",
      "placeholder": "Informe uma descrição para o motivo, condizente como código acima informado"
    },
    domProps: {
      "value": (_vm.motivos.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.motivos, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('descricao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('descricao')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('status')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "bt_ativo"
    }
  }, [_vm._v("Ativo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.bt_ativo),
      expression: "motivos.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "checked": "",
      "value": "1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.motivos.bt_ativo, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.motivos, "bt_ativo", 1)
      }
    }
  }), _vm._v(" Sim\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motivos.bt_ativo),
      expression: "motivos.bt_ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "value": "0"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.motivos.bt_ativo, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.motivos, "bt_ativo", 0)
      }
    }
  }), _vm._v(" Não\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ")])], 1)])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcf38dfa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/motivoDevolucao/EditarMotivos.vue
// module id = 2000
// module chunks = 2